import { Routes } from '@angular/router';
import { PaymentStripeComponent } from './payment-stripe/payment-stripe.component';

export const routes: Routes = [
  {
    path: 'blank',
    children: [
      {
        path: 'payment/:shortName',
        component: PaymentStripeComponent,
        title: 'InsurePay Payments',
        data: { blankPayment: true },
      },
    ],
  },
  {
    path: 'rtp',
    children: [
      {
        path: 'payment/:token',
        component: PaymentStripeComponent,
        title: 'InsurePay Payments',
        data: { rtpPayment: true },
      },
    ],
  },
  {
    path: '',
    redirectTo:
      '/rtp/payment/pmt_lnk_db4fc146d4f69642dcd6c4c7fdee4c39d433f2e2bd4344365e1d7b2d1689e4584d653c6fe82fc454657e84d9ab544c24aafccab5f84452fa49eca882f0f73ff5',
    // redirectTo: '/blank/payment/insurepay',
    pathMatch: 'full',
  },
];
